import React, { useState } from 'react'
import { Button, Dropdown, NavDropdown } from 'react-bootstrap'
import { formatCurrencyHasSymbol } from '../../../../../utils/commonFunctions'
import { formatDateBilling } from '../../billingOverview/component/CreditGrants/CreditGrants'
import CCModal2025 from '../../../../../components/ccModal2025'
import { onBoardingChangePlanDataApi } from '../../../../../constants/ApiConfigs'
import { callApiWithoutDispatch } from '../../../../../utils/apiUtils'
import { IoIosInformationCircleOutline } from 'react-icons/io'
import { I18n } from 'react-redux-i18n'
import { FaArrowRight } from 'react-icons/fa6'
import { BILLING_PLAN_TYPE } from '../../../../../features/signup/constantStep'
import { groupBillingItemsChangeFleetBillingPlan, handleResultBillingPayment } from '../../../utils/billingCommonFunc'
import PaymentMethodSelector from './PaymentMethodSelector'

const UpdateSubscription = ({
	newBillingUsage = {},
	previewBillingPlan,
	handleLoadBillingUsage,
	onResetPreviewBillingPlan,
	auth = {},
	context = {},
	billingUsage = {},
	previewAddOns,
	...props
}) => {
	const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(previewBillingPlan?.paymentMethods?.[0])

	const handleConfirmPayment = async () => {
		props.loadingActions.showLoadingSpiner()
		if(!selectedPaymentMethod) {
			context.notification('error', 'Please select a payment method')
			return
		}
		try {
			props.loadingActions.showLoadingSpiner()
			const response = await callApiWithoutDispatch(onBoardingChangePlanDataApi, {
				method: 'POST',
				body: JSON.stringify({
					fleetId: auth?.selectedFleet?.fleetId,
					planId: newBillingUsage.planId,
					billingType: newBillingUsage.billingType,
					billingDate: new Date().toISOString(),
					paymentId: selectedPaymentMethod?.paymentId,
					addOnIds: previewAddOns?.addOnIds || [],
					returnUrl: window.location.href,
				}),
			})
			const res = response?.res?.response || {}
			const { isSuccess, is3ds } = handleResultBillingPayment(res)
			if (isSuccess) {
				context.notification('success', 'Payment confirmed successfully')
				handleLoadBillingUsage()
				onResetPreviewBillingPlan()
			} else if (is3ds) {
				return;
			} else {
				context.notification('error', 'Failed to confirm payment')
			}
		} catch (error) {
			context.notification('error', 'Failed to confirm payment')
		} finally {
			props.loadingActions.hideLoadingSpiner()
		}
	}

	const formatValueCurrencyBaseBillingType = (item, billingUsage) => {
		const value = formatCurrencyHasSymbol(item.amount || 0, billingUsage.currencyISO)
		const isUnusedTime = item?.description?.includes('Unused time')
		const isSetupFee = item?.description?.includes('Setup fee') || item?.description?.includes('Setup Fees')
		const billingType = (isUnusedTime || isSetupFee) ? '' : billingUsage.billingType === BILLING_PLAN_TYPE.annual ? I18n.t('billingUsage.annual') : I18n.t('billingUsage.monthly')
		return <span style={{color: isUnusedTime ? '#04BE76' : '#FFFFFF'}}>
			{`${value}${billingType ? ` / ${billingType}` : ''}`}
		</span>
	}

	const { plan, addOns, tax } = groupBillingItemsChangeFleetBillingPlan(previewBillingPlan?.items)

	const isUpgradePlan = plan?.[1]?.name
	return (
		<>
			<div className="update-subscription preview-update">
				<div className="update-subscription-header">
					<p>{I18n.t('billingUsage.updateSubscription')}</p>
					<span>{I18n.t('billingUsage.reviewAndUpdate')}</span>
				</div>
				<div className="upgrade-from">
					<p className="upgrade-from-title">{I18n.t('billingUsage.upgrade')}</p>
					<p>
						<span className="upgrade-from-from">{I18n.t('billingUsage.from')}:</span>
						<span className="upgrade-from-from-name">{`${billingUsage.planName} - ${billingUsage.billingType === BILLING_PLAN_TYPE.annual ? I18n.t('billingUsage.annual') : I18n.t('billingUsage.monthly')}`}</span>
						<span className="upgrade-from-from-arrow"><FaArrowRight size={12} /></span>
						<span className="upgrade-from-to-name">{`${newBillingUsage.planName} - ${newBillingUsage.billingType === BILLING_PLAN_TYPE.annual ? I18n.t('billingUsage.annual') : I18n.t('billingUsage.monthly')}`}</span>
					</p>
				</div>
				<div>
					<div className="cr-plan">
						<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', gap: '10px', flexWrap: 'wrap' }}>
							<p>
								{I18n.t('billingUsage.plan')}
							</p>
							<p style={{ fontSize: '16px' }}>
								{
									`${formatCurrencyHasSymbol(newBillingUsage?.pricingConfigs?.find(p => p?.type === newBillingUsage?.billingType)?.fee || 0, newBillingUsage.currencyISO)}/${newBillingUsage.billingType === BILLING_PLAN_TYPE.annual ? I18n.t('billingUsage.annual') : I18n.t('billingUsage.monthly')}`
								}
							</p>
						</div>
						<p>
							{isUpgradePlan && <span style={{ fontSize: '16px', marginBottom: '10px' }}>{plan?.[1]?.name}</span>}
						</p>
					</div>
					<div>
						{
							plan?.[0]?.items?.map((item, index) => {
								if (!isUpgradePlan && index === 0) {
									return (
										<p style={{ fontSize: '16px'}} key={index}>
											<span>{item.name}</span>
										</p>
									)
								}
								if (item.amount === 0) {
									return null
								}
								return (
									<div className="cr-plan-item">
										<p>
											<span>{item.name}</span>
											<span>
												{formatValueCurrencyBaseBillingType(item, newBillingUsage)}
											</span>
										</p>
									</div>
								)
							})
						}
					</div>
				</div>
				<div className="itemUpdate">
					{
						addOns?.length > 0 && (
							<p style={{ fontSize: '16px', fontWeight: '700', marginTop: '10px' }}>Add-ons</p>
						)
					}
					{addOns?.map(item => {
							return (
								<div>
									{item.amount !== 0 && <p key={item.id}>
										<span className="add-on-name">{item.name}</span>
										<span className={`add-on-price ${item.amount <= 0 ? 'negative' : ''}`}>
											{
												`${formatCurrencyHasSymbol(item.amount || 0, newBillingUsage.currencyISO)}${!(item?.name?.includes('Setup fee') || item?.name?.includes('Setup Fees')) ? ('/' + (newBillingUsage.billingType === BILLING_PLAN_TYPE.annual ? 'Annual' : 'Monthly')) : ''}`
											}
										</span>
									</p>}
									{
									item.items.map(item => {
										if (item.amount === 0) {
											return null
										}
										return (
											<p key={item._id} style={{ marginLeft: '10px' }}>
												<span className="add-on-name">{item.name}</span>
												{formatValueCurrencyBaseBillingType(item, newBillingUsage)}
											</p>
										)
									})
								}
								</div>
							)
						})
					}
				</div>
				{
					tax?.length > 0 && (
						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
							<p style={{ fontSize: '16px', fontWeight: '700', marginTop: '10px' }}>Tax</p>
							<p>{formatCurrencyHasSymbol(tax?.[0]?.amount || 0, billingUsage.currencyISO)}</p>
						</div>
					)
				}
				<p className="total-due-today">
					<span>{I18n.t('billingUsage.totalDueToday')}</span>
					<span>{formatCurrencyHasSymbol(previewBillingPlan?.amountDue || 0, newBillingUsage.currencyISO)}</span>
				</p>
				<div className="d-flex align-items-start" style={{border: '1px solid #3F4350', padding: '10px', borderRadius: '5px', marginTop: '16px'}}>
					<IoIosInformationCircleOutline fontSize={24} style={{ color: '#60A5FA' }} />
					<p style={{ fontSize: '14px', fontWeight: '500', marginLeft: '10px' }}>
						<span style={{ color: '#60A5FA' }}>{I18n.t('billingUsage.howProrationWorks')}</span> <br/>
						<span>
							{I18n.t('billingUsage.prorationDescription')}
						</span>
					</p>
				</div>
				{
					previewBillingPlan?.paymentMethods?.length > 0 && (
						<>
							<PaymentMethodSelector
								selectedPaymentMethod={selectedPaymentMethod}
								paymentMethods={previewBillingPlan?.paymentMethods}
								onSelectPaymentMethod={setSelectedPaymentMethod}
							/>
							<div className="text-center">
								<Button className="btn-save" onClick={handleConfirmPayment}>{I18n.t('billingUsage.confirmPayment')}</Button>
							</div>
						</>
					)
				}
			</div>
		</>
	)
}

export default UpdateSubscription

